const SvgMinus3 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 1">
    <path fill="#373737" fillRule="evenodd" d="M18 0H0v1h18z" clipRule="evenodd" />
  </svg>;
export default SvgMinus3;